
import React, { useEffect, useRef } from 'react';

import IGenericOption from '../../interfaces/IGenericOption';

import RadioButton from '../RadioButton';

import styles from './styles.module.scss';

interface IRadioButtonsGroup {
  selected?: IGenericOption | null;
  setSelected(selected: IGenericOption): void;
  options: IGenericOption[];
  maxHeight?: number;
}

const RadioButtonsGroup = ({ selected, setSelected, options, maxHeight }: IRadioButtonsGroup) => {
  const optionsContainer = useRef<HTMLDivElement>(null);

  // scrolling to the top on search
  useEffect(() => {
    optionsContainer.current?.scrollTo(0, 0)
  }, [options])

  const renderOptions = () => {
    return options.map((option) => {
      return (
        <RadioButton 
          key={typeof option.value === 'string' ? option.value : option.label}
          isChecked={option === selected}
          radioButton={option}
          setSelected={setSelected} 
        />
      )
    });
  } 
  
  const style = {
    maxHeight,
    overflow: !!maxHeight ? 'auto' : undefined
  }

  return (
    <div className={styles.radioButtons} style={style} ref={optionsContainer}>
      <div className={styles.radioButtonsGroup}>
        { renderOptions() }
      </div>
    </div>
    
  )
}

export default RadioButtonsGroup;